import { render } from "./TasksOpenListView.vue?vue&type=template&id=84bad286"
import script from "./TasksOpenListView.vue?vue&type=script&lang=js"
export * from "./TasksOpenListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__